import { ProductCodeTypeLiterals } from "../organization/org-product";

const legalPageBaseURL = "https://graffer.jp/legal/";
export const formatErrorMessage = `利用規約のURLは${legalPageBaseURL}から始まるURLを入力してください。`;

export const validateTermsOfUseURL = (
  productCode: ProductCodeTypeLiterals,
  termsOfUseURL: string,
): boolean => {
  switch (productCode) {
    case "SmartApply":
      return true;
    case "Survey": {
      if (termsOfUseURL === "") {
        return true;
      }
      const regex = new RegExp(`^${legalPageBaseURL}.+$`);
      return regex.test(termsOfUseURL);
    }
    case "BoothReserve":
      return true;
    case "MadoguchiEditor":
      return true;
    case "TtzkGuide":
      return true;
    case "AIStudio":
      return true;
    case "Portal":
      return true;
    case "Call":
      return true;
    case "KintoneExport":
      return true;
    case "ServiceAccount":
      return true;
    case "NinteiShoukai":
      return true;
  }
};
